// sliders.js
import Swiper from 'swiper/bundle';

export function Sliders() {
  document.addEventListener('DOMContentLoaded', () => {
    const instances = new WeakMap();

    // Opzioni comuni
    const commonTouchOpts = {
      allowTouchMove: true,
      simulateTouch: true,
      grabCursor: true,
      threshold: 4,
      touchRatio: 1,
      touchStartPreventDefault: false,
      passiveListeners: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1,
      },
      a11y: { enabled: true },
      watchOverflow: true,
      observer: true,
      observeParents: true,

      // IMPORTANT: default disabilitati per evitare undefined
      pagination: { enabled: false },
      navigation: { enabled: false },
    };

    const withCommon = (specific = {}) => {
      return {
        ...commonTouchOpts,
        ...specific,
        // merge sottochiavi mantenendo enabled se già impostato
        pagination: specific.pagination
          ? { ...commonTouchOpts.pagination, ...specific.pagination }
          : { ...commonTouchOpts.pagination },
        navigation: specific.navigation
          ? { ...commonTouchOpts.navigation, ...specific.navigation }
          : { ...commonTouchOpts.navigation },
        breakpoints: specific.breakpoints ? { ...specific.breakpoints } : undefined,
      };
    };

    const variants = {
      // === SLIDER FAST-PROJECTS ===
      'three-slide': (el) => {
        const pagEl = el.querySelector('.swiper-pagination');
        return withCommon({
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 24,
          loop: false,
          pagination: pagEl
            ? { el: pagEl, clickable: true, enabled: true }
            : { enabled: false },
          breakpoints: {
            576: { slidesPerView: 2,   spaceBetween: 20 },
            992: { slidesPerView: 3.2, spaceBetween: 24 },
          },
        });
      },
      
      // === HERO BACKGROUND (1 per volta, autoplay 3s) ===
      'hero-home-bg': (el) => {
        return withCommon({
          slidesPerView: 1,
          slidesPerGroup: 1,
          loop: true,
          spaceBetween: 0,
          allowTouchMove: false, // opzionale: il bg non si trascina
          effect: 'fade',
          speed: 800,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          pagination: { enabled: false },
          navigation: { enabled: false },
        });
      },
      // === SLIDER CON FRECCE (settori) ===
      'three-partial-arrows': (el) => {
        const scope = el.closest('.position-relative') || el.parentElement || document;
        const nextEl = scope.querySelector('.swiper-button-next');
        const prevEl = scope.querySelector('.swiper-button-prev');
        const navEnabled = !!(nextEl && prevEl);

        return withCommon({
          spaceBetween: 24,
          slidesPerView: 1.2,
          slidesPerGroup: 1,
          loop: false,
          centeredSlides: false,
          navigation: navEnabled
            ? { nextEl, prevEl, enabled: true }
            : { enabled: false },
          breakpoints: {
            576:  { slidesPerView: 2,   slidesPerGroup: 1, spaceBetween: 20 },
            768:  { slidesPerView: 2.2, slidesPerGroup: 1, spaceBetween: 20 },
            992:  { slidesPerView: 3,   slidesPerGroup: 1, spaceBetween: 24 },
            1200: { slidesPerView: 3.2, slidesPerGroup: 1, spaceBetween: 24 },
          },
        });
      },

      // === SLIDER SOLO MOBILE ===
      'only-mobile-one-slide': (el) => {
        const pagEl = el.querySelector('.swiper-pagination');
        return withCommon({
          spaceBetween: 16,
          loop: false,
          slidesPerView: 1,
          slidesPerGroup: 1,
          pagination: pagEl
            ? { el: pagEl, clickable: true, enabled: true }
            : { enabled: false },
        });
      },
    };

    const create = (el, opts) => {
      if (instances.get(el)) return instances.get(el);
      const swiper = new Swiper(el, opts);
      instances.set(el, swiper);
      el.classList.remove('is-static');
      return swiper;
    };

    const destroy = (el) => {
      const swiper = instances.get(el);
      if (swiper) {
        swiper.destroy(true, true);
        instances.delete(el);
      }
      el.classList.add('is-static');
    };

    const initSlider = (el) => {
      const variantName = el.dataset.variant;
      const getOpts = variants[variantName];
      if (!getOpts) return;

      if (variantName === 'only-mobile-one-slide') {
        const mql = window.matchMedia('(min-width: 768px)');
        const setup = () => (mql.matches ? destroy(el) : create(el, getOpts(el)));
        setup();
        if (!el._mqlListenerAttached) {
          mql.addEventListener('change', setup);
          el._mqlListenerAttached = true;
        }
        return;
      }

      create(el, getOpts(el));
    };

    document.querySelectorAll('.js-slider[data-variant]').forEach(initSlider);
  });
}